import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import axiosInstance from '../../config/axios';
import {
  fetchAnalysesSuccess,
  fetchAnalysesFailure,
  fetchAnalysisDetailSuccess,
  fetchAnalysisDetailFailure,
  deleteAnalysisSuccess,
  deleteAnalysisFailure,
} from '../reducers/analysisReducer';

function* fetchAnalyses(action: any): Generator<any, void, any> {
  try {
    const response: AxiosResponse = yield call(axiosInstance.get, '/api/analysis', {
      params: action.payload,
    });

    yield put(fetchAnalysesSuccess({
      analyses: response.data.analyses,
      pagination: response.data.pagination,
    }));
  } catch (error: any) {
    yield put(fetchAnalysesFailure(error.response?.data?.message || 'Failed to fetch analyses'));
  }
}

function* fetchAnalysisDetail(action: any): Generator<any, void, any> {
  try {
    const response: AxiosResponse = yield call(axiosInstance.get, `/api/analysis/${action.payload}`);

    yield put(fetchAnalysisDetailSuccess({
      analysis: response.data.analysis,
      employees: response.data.employees,
    }));
  } catch (error: any) {
    yield put(fetchAnalysisDetailFailure(error.response?.data?.message || 'Failed to fetch analysis'));
  }
}

function* deleteAnalysis(action: any): Generator<any, void, any> {
  try {
    yield call(axiosInstance.delete, `/api/analysis/${action.payload}`);

    yield put(deleteAnalysisSuccess(action.payload));
  } catch (error: any) {
    yield put(deleteAnalysisFailure(error.response?.data?.message || 'Failed to delete analysis'));
  }
}

export default function* analysisSaga() {
  yield takeLatest('analysis/fetchAnalysesRequest', fetchAnalyses);
  yield takeLatest('analysis/fetchAnalysisDetailRequest', fetchAnalysisDetail);
  yield takeLatest('analysis/deleteAnalysisRequest', deleteAnalysis);
}